import { handleDay } from "@/utils/helper";
import { PaginationType } from "@/utils/interface.global";
import React, { useEffect, useState, memo } from "react";
import { useSearchParams } from "react-router-dom";
import ListVoucherForEvent from "@/pages/PhieuThayDau/ListVoucherForEvent";
import TableRendering from "@/components/table";
import { getUserData } from "@/redux/slices/userSlices";
import { useSelector } from "react-redux";
import Api from "@/components/api/api";
import ToastProvider from "@/hooks/useToastProvider";
import SearchComponents from "@/components/search";
import { ListEventType } from "@/utils/interface.global";

const ListEvent: React.FC = () => {
  const user = useSelector(getUserData);
  const [searchParams] = useSearchParams();
  const [currentPage, setCurrentPage] = useState<number>(0);
  const [limit] = useState(8);
  const [data, setData] = useState<[] | ListEventType>([]);
  const [eventData, setEventData] = useState("");
  const [pagination, setPagination] = useState<null | PaginationType>(null);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [eventID, setEventID] = useState<null | string>(
    !searchParams.get("eventID") ? null : searchParams.get("eventID")
  );

  const fetchDataVoucher = async () => {
    try {
      const reqUrl = "/get-list-event";
      const params = {
        key: user.key_login,
        user_id: user.id,
        name_event: eventData,
        start_date: startDate,
        end_date: endDate,
        start: currentPage,
        limit: limit,
      };
      const res: any = await Api.post(reqUrl, params);
      if (!res.status)
        return ToastProvider({ type: "error", content: res.data.message });
      setData(res.data.data);
      setPagination(res.data.pagination);
    } catch (error) {
      ToastProvider({
        type: "error",
        content: "Có lỗi xảy ra trong quá trình tải data. Vui lòng thử lại",
      });
    }
  };

  const onChangeEventData = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEventData(event.target.value);
  };

  const handleSearchFunction = () => {
    //eventData, startDate, endDate
    // fetchDataVoucher();
  };

  const props = {
    setPropsID: setEventID,
    currentPage,
    nameState: "eventID",
    setCurrentPage,
    dataRendering: data,
    pagination,
    contentHeader: `Số sự kiện đã tham gia: ${pagination?.total}`,
    isAction: true,
  };

  useEffect(() => {
    fetchDataVoucher();
    return () => setData([]);
  }, [currentPage]);

  return (
    <div className="list-container">
      {!eventID && (
        <>
          <SearchComponents
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            placeHolder="Nhập Tên Sự Kiện"
            nameInput="Tên Sự Kiện"
            dataInput={eventData}
            onChangeFunc={onChangeEventData}
            searchFunc={handleSearchFunction}
          />
          <TableRendering {...props} />
        </>
      )}
      {eventID && <ListVoucherForEvent setEventID={setEventID} />}
    </div>
  );
};

export default memo(ListEvent);
